import { Pipe, PipeTransform } from '@angular/core';
import { IGetBookingsCommonResponse } from "../../service/resources/booking/interfaces/IGetBookings";

@Pipe({
    name: 'isSelectedBooking',
})

export class IsSelectedBookingPipe implements PipeTransform {
    public transform(selectedOptions: IGetBookingsCommonResponse[], code: string): boolean {
        return selectedOptions.findIndex((option: IGetBookingsCommonResponse): boolean => option.code === code) > -1;
    }
}
